// ============================================================================
// SPANISH BIBLE PASSAGES - Reina Valera 1960
// ============================================================================
// Pasajes bíblicos en español con referencias Strong

export const biblePassagesEs = {
  "Genesis_1": {
    book: "Génesis",
    chapter: 1,
    title: "La Creación del mundo",
    verses: [
      { number: 1, text: "En el principio creó Dios los cielos y la tierra.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "Y la tierra estaba desordenada y vacía, y las tinieblas estaban sobre la faz del abismo, y el Espíritu de Dios se movía sobre la faz de las aguas.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "Y dijo Dios: Sea la luz; y fue la luz.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "Y vio Dios que la luz era buena; y separó Dios la luz de las tinieblas.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "Y llamó Dios a la luz Día, y a las tinieblas llamó Noche. Y fue la tarde y la mañana un día.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "Luego dijo Dios: Haya expansión en medio de las aguas, y separe las aguas de las aguas.", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "E hizo Dios la expansión, y separó las aguas que estaban debajo de la expansión, de las aguas que estaban sobre la expansión. Y fue así.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "Y llamó Dios a la expansión Cielos. Y fue la tarde y la mañana el día segundo.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "Y creó Dios al hombre a su imagen, a imagen de Dios lo creó; varón y hembra los creó.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "Y vio Dios todo lo que había hecho, y he aquí que era bueno en gran manera. Y fue la tarde y la mañana el día sexto.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Salmo_23": {
    book: "Salmos",
    chapter: 23,
    title: "Jehová es mi pastor",
    verses: [
      { number: 1, text: "Jehová es mi pastor; nada me faltará.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "En lugares de delicados pastos me hará descansar; junto a aguas de reposo me pastoreará.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Confortará mi alma; me guiará por sendas de justicia por amor de su nombre.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Aunque ande en valle de sombra de muerte, no temeré mal alguno, porque tú estarás conmigo; tu vara y tu cayado me infundirán aliento.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Aderezas mesa delante de mí en presencia de mis angustiadores; unges mi cabeza con aceite; mi copa está rebosando.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Ciertamente el bien y la misericordia me seguirán todos los días de mi vida, y en la casa de Jehová moraré por largos días.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Juan_3": {
    book: "Juan",
    chapter: 3,
    title: "Jesús y Nicodemo",
    verses: [
      { number: 16, text: "Porque de tal manera amó Dios al mundo, que ha dado a su Hijo unigénito, para que todo aquel que en él cree, no se pierda, mas tenga vida eterna.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Porque no envió Dios a su Hijo al mundo para condenar al mundo, sino para que el mundo sea salvo por él.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "El que en él cree, no es condenado; pero el que no cree, ya ha sido condenado, porque no ha creído en el nombre del unigénito Hijo de Dios.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Filipenses_4": {
    book: "Filipenses",
    chapter: 4,
    title: "La paz de Dios",
    verses: [
      { number: 4, text: "Regocijaos en el Señor siempre. Otra vez digo: ¡Regocijaos!", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Por nada estéis afanosos, sino sean conocidas vuestras peticiones delante de Dios en toda oración y ruego, con acción de gracias.", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "Y la paz de Dios, que sobrepasa todo entendimiento, guardará vuestros corazones y vuestros pensamientos en Cristo Jesús.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Todo lo puedo en Cristo que me fortalece.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesEs;
